import React, { useEffect, useState } from 'react';
import FramePlayer from '../utils/FramePlayer';
import ImageButton from '../utils/ImageButton';
import '../css/button.css';
import '../css/menu_dida.css';
import anime from 'animejs';
import { Navigate, useNavigate } from 'react-router-dom';
import lang from '../lang.json';

const MenuMusic = (props) => {

    const langue = props.langue;
    const setLangue = props.setLangue;
    const texts = lang.lang[`lang_${langue}`].menu_music;

    const [b1hover, setB1hover] = useState(false);
    const [b2hover, setB2hover] = useState(false);
    const [b3hover, setB3hover] = useState(false);
    const [b4hover, setB4hover] = useState(false);
    const [b5hover, setB5hover] = useState(false);
    const [b6hover, setB6hover] = useState(false);
    const [b7hover, setB7hover] = useState(false);
    const [b8hover, setB8hover] = useState(false);

    const [isIntroFinished, setIsIntroFinished] = useState(false);

    const navigate = useNavigate();

    useEffect(() => {
        setTimeout(() => {
            setIsIntroFinished(true);
        }, 6200);
    }, []);

    return (<>

        <FramePlayer dirName="menu_music"
            frameNumber={63}
            fps={10}
            initialDelay={200}
        />

        {/* titre menu dida en jaune en haut à gauche */}
        <p
            className='button'
            style={{
                position: 'absolute',
                left: 10,
                top: 0,
                color: 'yellow',
                fontSize: '15px',
            }}
        >{texts.lang1}</p>

        {/* label bouton */}
        <div
            className='button'
            style={{
                position: 'absolute',
                left: 110,
                top: 50,
                width: '100px',
                color: '#f74888',
                fontSize: '15px',
                textAlign: 'center',
                opacity: b1hover ? 1 : 0.2,
                cursor: 'pointer',
                display: isIntroFinished ? 'block' : 'none',
            }}
            //Opacity 1 when hover
            onMouseEnter={() => {
                setB1hover(true);
            }}
            onMouseLeave={() => {
                setB1hover(false);
            }}
            onClick={() => {
                navigate(process.env.PUBLIC_URL + '/module/2-captation/');
            }}
        >
            <p>
                {texts.lang2}
            </p>
            <p style={{
                fontSize: '11px',
            }}>
                {texts.lang12}
            </p>
        </div>

        <div
            className='button'
            style={{
                position: 'absolute',
                left: 313,
                top: 32,
                width: '100px',
                color: '#f74888',
                fontSize: '15px',
                textAlign: 'center',
                opacity: b2hover ? 1 : 0.2,
                cursor: 'pointer',
                display: isIntroFinished ? 'block' : 'none',
            }}
            //Opacity 1 when hover
            onMouseEnter={() => {
                setB2hover(true);
            }}
            onMouseLeave={() => {
                setB2hover(false);
            }}
            onClick={() => {
                navigate(process.env.PUBLIC_URL + '/module/2-captation-video/');
            }}
        >
            <p>
                {texts.lang3}
            </p>
            <p style={{
                fontSize: '11px',
            }}>
                {texts.lang13}
            </p>
        </div>

        <div
            className='button'
            style={{
                position: 'absolute',
                left: 540,
                top: 5,
                width: '100px',
                color: '#f74888',
                fontSize: '15px',
                textAlign: 'center',
                opacity: b3hover ? 1 : 0.2,
                cursor: 'pointer',
                display: isIntroFinished ? 'block' : 'none',
            }}
            //Opacity 1 when hover
            onMouseEnter={() => {
                setB3hover(true);
            }}
            onMouseLeave={() => {
                setB3hover(false);
            }}
            onClick={() => {
                navigate(process.env.PUBLIC_URL + '/module/3-imitation-5-walking/');
            }}
        >
            <p>
                {texts.lang4}
            </p>
            <p style={{
                fontSize: '11px',
            }}>
                {texts.lang14}
            </p>
        </div>

        <div
            className='button'
            style={{
                position: 'absolute',
                left: 250,
                top: 140,
                width: '100px',
                color: '#f74888',
                fontSize: '15px',
                textAlign: 'center',
                opacity: b4hover ? 1 : 0.2,
                cursor: 'pointer',
                display: isIntroFinished ? 'block' : 'none',
            }}
            //Opacity 1 when hover
            onMouseEnter={() => {
                setB4hover(true);
            }}
            onMouseLeave={() => {
                setB4hover(false);
            }}
            onClick={() => {
                navigate(process.env.PUBLIC_URL + '/module/4-transformationA-3-arpeges/');
            }}
        >
            <p>
                {texts.lang6}
            </p>
            <p style={{
                fontSize: '11px',
            }}>
                {texts.lang16}
            </p>
        </div>

        <div
            className='button'
            style={{
                position: 'absolute',
                left: 443,
                top: 130,
                width: '100px',
                color: '#f74888',
                fontSize: '15px',
                textAlign: 'center',
                opacity: b5hover ? 1 : 0.2,
                cursor: 'pointer',
                display: isIntroFinished ? 'block' : 'none',
            }}
            //Opacity 1 when hover
            onMouseEnter={() => {
                setB5hover(true);
            }}
            onMouseLeave={() => {
                setB5hover(false);
            }}
            onClick={() => {
                navigate(process.env.PUBLIC_URL + '/module/5-transformationB-2-hothouse/');
            }}
        >
            <p>
                {texts.lang7}
            </p>
            <p style={{
                fontSize: '11px',
            }}>
                {texts.lang17}
            </p>
        </div>

        <div
            className='button'
            style={{
                position: 'absolute',
                left: 202,
                top: 280,
                width: '100px',
                color: '#f74888',
                fontSize: '15px',
                textAlign: 'center',
                opacity: b6hover ? 1 : 0.2,
                cursor: 'pointer',
                display: isIntroFinished ? 'block' : 'none',
            }}
            //Opacity 1 when hover
            onMouseEnter={() => {
                setB6hover(true);
            }}
            onMouseLeave={() => {
                setB6hover(false);
            }}
            onClick={() => {
                navigate(process.env.PUBLIC_URL + '/module/5-transformationB-5-goodbye/');
            }}
        >
            <p>
                {texts.lang8}
            </p>
            <p style={{
                fontSize: '11px',
            }}>
                {texts.lang18}
            </p>
        </div>

        <div
            className='button'
            style={{
                position: 'absolute',
                left: 367,
                top: 267,
                width: '100px',
                color: '#f74888',
                fontSize: '15px',
                textAlign: 'center',
                opacity: b7hover ? 1 : 0.2,
                cursor: 'pointer',
                display: isIntroFinished ? 'block' : 'none',
            }}
            //Opacity 1 when hover
            onMouseEnter={() => {
                setB7hover(true);
            }}
            onMouseLeave={() => {
                setB7hover(false);
            }}
            onClick={() => {
                navigate(process.env.PUBLIC_URL + '/module/6-controle-2-lubatyscaphe/');
            }}
        >
            <p>
                {texts.lang9}
            </p>
            <p style={{
                fontSize: '11px',
            }}>
                {texts.lang19}
            </p>
        </div>

        <div
            className='button'
            style={{
                position: 'absolute',
                left: 550,
                top: 247,
                width: '100px',
                color: '#f74888',
                fontSize: '15px',
                textAlign: 'center',
                opacity: b8hover ? 1 : 0.2,
                cursor: 'pointer',
                display: isIntroFinished ? 'block' : 'none',
            }}
            //Opacity 1 when hover
            onMouseEnter={() => {
                setB8hover(true);
            }}
            onMouseLeave={() => {
                setB8hover(false);
            }}
            onClick={() => {
                navigate(process.env.PUBLIC_URL + '/module/6-controle-1-video/');
            }}
        >
            <p>
                {texts.lang10}
            </p>
            <p style={{
                fontSize: '11px',
            }}>
                {texts.lang20}
            </p>
        </div>
    </>

    );
}

export default MenuMusic;